<template>
  <vbt-badge
    v-if="status"
    :color="color"
    small
  >
    <slot />
  </vbt-badge>
  <span v-else>
    -
  </span>
</template>

<script>
export default {
  name: 'KernelStatusBadge',
  props: {
    // Must return color string
    colorResolver: {
      type: Function,
      default: null,
    },
    status: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    color() {
      if (this.colorResolver) {
        return this.colorResolver(this.status);
      }

      const { status: s } = this;

      if (s >= 1 && s <= 99) {
        return 'success';
      }
      if (s >= 100 && s <= 199) {
        return 'info';
      }
      if (s >= 200 && s <= 299) {
        return 'warning';
      }
      if (s >= 300 && s <= 399) {
        return 'error';
      }
      return 'default';
    },
  },
};
</script>
